import DataDay from "./dataSelectDay";
import DataType from "./dataSelectType";
function sumDataAll({ sumDataDay, textDay, textType }) {
//console.log("sumDataDay", sumDataDay);
// นับ CONTNO ทั้งหมด
const totalContnoCount = sumDataDay.length;
// นับ CONTNO ไม่ซ้ำ
//const uniqueContnoCount = new Set(sumDataDay.map(item => item.CONTNO)).size;
// นับเฉพาะ DATA_TYPE === 'ab'
//const itemACount = sumDataDay.filter(item => item.itemA === "ยังไม่เคยสืบ").length;
//เปลี่ยนจาก itemA = "ยังไม่เคยสืบ"เป็น itemAA = 1
const itemACount = sumDataDay.filter(item => item.itemAA === 1).length;
const itemBCount = sumDataDay.filter(item => item.itemB === "ยังไม่บอกเลิก").length;

//console.log("totalContnoCount", totalContnoCount);
//console.log("ยังไม่เคยสืบ", itemACount);
//console.log("ยังไม่บอกเลิก", itemBCount);

//เช็คหา จำนวนวัน 120 /180 /270 จากตัวเลือก
const checkDataDay = DataDay.find(item => item.value === textDay)?.label;

//เช็คหา จำนวนวัน 120 /180 /270 จากตัวเลือก
const checkDataType = DataType.find(item => item.value === textType)?.label;

const DataDayAB = [ 
{ countType: checkDataType, countDay:checkDataDay,  countCONTNO: totalContnoCount, countItemA: itemACount, countItemB:itemBCount },
];
//console.log("DataDayAB", DataDayAB);
return  DataDayAB;

}
export default sumDataAll;
